<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <!-- <div class="flex flex-col space-y-1.5 p-6"> -->
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Administración de Proveedores
    </h3>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Proveedor
    </button>
  </div>

  <div
    class="grow h-full flex items-start p-6 pt-0 overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200"
  >
    <div class="h-full w-full">
      <table class="w-full">
        <thead>
          <tr class="border-b border-border">
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Nombre
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Correo Electrónico
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Teléfono
            </th>
            <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Acciones
            </th>
          </tr>
        </thead>

        <tbody>
          @for(supplier of suppliers; track supplier.id) {
          <tr class="border-b border-border hover:bg-accent transition-colors">
            <td class="py-4 px-4">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shrink-0"
                >
                  <ng-icon
                    name="lucideTruck"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </div>
                <div>
                  <p class="text-foreground font-medium text-sm">
                    {{ supplier.name }}
                  </p>
                </div>
              </div>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs">
              {{ supplier.email }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs">
              {{ supplier.phone }}
            </td>
            <td class="py-4 px-4 w-1/12">
              <div class="flex items-center">
                <button
                  class="ghost sm text-muted-foreground hover:text-foreground"
                  type="button"
                  (click)="updateSupplier(supplier)"
                >
                  <ng-icon
                    name="lucidePenLine"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>

                <button
                  class="ghost sm text-destructive"
                  type="button"
                  (click)="deleteSupplier(supplier.id)"
                >
                  <ng-icon
                    name="lucideTrash2"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-supplier-form
  [(showModal)]="showModal"
  [existingSupplier]="existingSupplier"
></app-supplier-form>
